<template>
  <div class="spinner"></div>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

.spinner:before {
  content: '';
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  position: absolute;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border-top: 5px solid $primary;
  border-right: 5px solid transparent;
  animation: spinner 0.6s linear infinite;
}
</style>
